export class DateHelper {
    static getWorkingDay(): Date {
        const dayOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const day = new Date();
        const today = dayOfWeek[day.getDay()];
        const isTradingHours = day.getHours() >= 9 && day.getMinutes() >= 10;
        console.log(day);
        console.log(isTradingHours);

        if (today === 'Monday' && !isTradingHours) {
            day.setDate(day.getDate() - 3);
        }

        if (today === 'Saturday') {
            day.setDate(day.getDate() - 1);
        }

        if (today === 'Sunday') {
            day.setDate(day.getDate() - 2);
        }

        if (!isTradingHours) {
            day.setDate(day.getDate() - 1);
        }

        return day;
    }

    static getWorkingDay2(): Date {
        const dayOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const day = new Date();
        const today = dayOfWeek[day.getDay()];
        const isTradingHours = day.getHours() >= 9 && day.getMinutes() >= 10;
       

        if (today === 'Monday' && !isTradingHours) {
            day.setDate(day.getDate() - 3);
        }

        if (today === 'Saturday') {
            day.setDate(day.getDate() - 1);
        }

        if (today === 'Sunday') {
            day.setDate(day.getDate() - 2);
        }

        // if (!isTradingHours) {
        //     day.setDate(day.getDate() - 1);
        // }

        return day;
    }
}